import { globalStore } from 'stores';
import { debug, request, track, user, utils, globalPageConfig } from 'lib';
import { UiModal, UiToast } from 'components';
import assign from 'lodash/assign';

const { publishStreamConfig, zgConfig } = globalPageConfig;

const log = debug.create('zgWeb');
const error = debug.create('zgWeb:error');
let ZegoClient;

const STATE_TYPE = ['start', 'error', 'retry'];
const PULL_ROOT = '://pull-aliyun.memeyule.com/memeyuleNew/';

const STREAM_TYPE = {
  topc: 2,
  sm: 0,
  pk_host: 1,
  pk_star: 0,
};

class ZegoBase {
  // anchorRoom 个播
  // stage 舞台房
  // pk pk房
  typeName = '';

  roomId = '';

  userId = '';

  anchorId = '';

  nickName = '';

  streamType = null;

  pushStreamId = ''; // 推流id

  loginUserId = ''; // 登录即构的id

  zg = null;

  isLoginZego = false;

  isPreviewed = false; // 是否预览过

  isPublishing = false; // 是否预览过

  video = null;

  pushRtmpUrl = ''; // 推流地址

  appId = 2999925240; // 173230341

  server = [
    'wss://webliveroom2999925240-api.zego.im/ws',
    'wss://webliveroom2999925240-api-bak.zego.im/ws',
  ];

  logUrl = 'wss://weblogger2999925240-api.zego.im/log';

  get trackName() {
    return `zg_${this.typeName}`;
  }

  trackLog(event_type, content, params, ...rest) {
    track.send({
      event: this.trackName,
      event_type,
      content,
      params,
    });
    log(event_type, content, params, ...rest);
  }

  async init(typeName, roomId, userId, nickName) {
    document.querySelector('html').classList.add('RTCVideoPlayer');

    this.typeName = typeName;
    this.roomId = `${roomId}`;
    this.userId =
      userId +
      (typeName === 'anchorRoom' || typeName === 'pcClientRoom'
        ? ''
        : `_${typeName}`);

    this.streamId =
      userId +
      (typeName === 'anchorRoom' || typeName === 'pcClientRoom'
        ? ''
        : `_${typeName}`);
    this.loginUserId = `${userId}_${typeName}`;
    this.anchorId = `${userId}`;
    this.nickName = nickName;
    // if (!ZegoClient) {
    //   const res = await import('widgets/lib/zego/jZego-rtc-2.7.0');
    //   log('load zego sdk', res);
    //   ZegoClient = res.ZegoClient;
    // }

    ZegoClient = window.ZegoClient;

    ZegoClient.supportDetection(
      (res) => {
        // if (!res.capture) {
        //   track.send({
        //     event: this.trackName,
        //     event_type: 'zg_no_device'
        //   })
        //   return UiModal.alert('', '未获取到设备摄像头或者麦克风');
        // }
        if (!res.webRtc) {
          this.trackLog('zg_no_webrtc');

          const content = (
            <div style={{ textAlign: 'left' }}>
              <div>
                当前浏览器版本过低，请更新浏览器以支持更多功能，获得更好体验，点击下载
              </div>
              <div>
                <a
                  href="http://chrome.360.cn/"
                  className="text-primary"
                  target="_blank"
                  data-log="event=upgrade_browser&desc=360"
                  rel="noreferrer"
                >
                  360极速浏览器
                </a>
                （开启极速模式）
              </div>
              <div>
                <a
                  href="https://browser.qq.com/"
                  className="text-primary"
                  target="_blank"
                  data-log="event=upgrade_browser&desc=qq"
                  rel="noreferrer"
                >
                  QQ浏览器
                </a>
                （开启极速模式）
              </div>
              <div>
                <a
                  href="https://chrome.google.com"
                  className="text-primary"
                  target="_blank"
                  data-log="event=upgrade_browser&desc=chrome"
                  rel="noreferrer"
                >
                  Google Chrome浏览器
                </a>
              </div>
            </div>
          );
          return UiModal.alert('浏览器升级提示', content);
        }

        this._initZego();
      },
      () => {
        this.trackLog('zg_detect_err');
        UiModal.alert('', '浏览器环境检测异常');
      },
    );
  }

  _initZego() {
    this.zg = new ZegoClient();

    const options = {
      appid: this.appId, // 必填，应用id，由即构分配
      idName: this.loginUserId, // 必填，用户自定义id，全局唯一
      nickName: this.nickName, // 必填，用户自定义昵称
      remoteLogLevel: 0, // 上传日志最低级别，建议跟 logLevel 一致
      logLevel: 2, // 日志级别，debug:0,info:1,warn:2,error:3,report:99,disable:100（数字越大，日志越少），建议选择 1
      server: this.server, // 必填，接入服务器地址，由即构分配
      logUrl: this.logUrl, // 必填，logServer 地址，由即构分配
      audienceCreateRoom: true, // 设置为用户也可以创建房间，避免可能出现的用户身份问题
    };

    log('zego config:', options);

    this.zg.config(options);

    // 房间断开
    this.zg.onDisconnect = (err) => {
      this.trackLog('onDisconnect');
      UiToast.info('房间已断开连接，即将回到首页', () => {
        location.href = '/';
      });
    };

    // 网络中断回调
    this.zg.onTempBroken = () => {
      // UiToast.info('网络中断');
      this.trackLog('onTempBroken');
    };

    // 重连成功回调
    this.zg.onReconnect = () => {
      // UiToast.info('网络恢复');
      this.trackLog('onReconnect');
    };

    this.zg.onKickOut = (err) => {
      this.trackLog('onKickOut');
      this.onKickOut();
      UiToast.info('您已重复进入当前房间，即将回到首页', () => {
        location.href = '/';
      });
    };

    // 流更新通知
    this.zg.onStreamUpdated = (type, streamList) => {
      // 0:添加， 1:删除
      log('onStreamUpdated', type, streamList);
      this.trackLog('onStreamUpdated', {
        type,
        streamList,
      });

      this.onStreamUpdated(type, streamList);
    };

    // 拉流状态变更通知
    // type start:0, error:1, retry: 2
    this.zg.onPlayStateUpdate = (type, streamId, error) => {
      this.trackLog(
        'onPlayStateUpdate',
        {
          type,
          error,
        },
        {
          streamId,
        },
      );
      log('onPlayStateUpdate', type, streamId, STATE_TYPE[type]);
      this.onPlayStateUpdate(type, streamId, error);
    };

    // 拉流的首帧画面通知
    this.zg.onVideoSizeChanged = (streamId, videoWidth, videoHeight) => {
      this.trackLog(
        'onVideoSizeChanged',
        {
          videoWidth,
          videoHeight,
        },
        {
          streamId,
        },
      );
      this.onVideoSizeChanged(streamId, videoWidth, videoHeight);
    };

    // 拉流质量回调
    this.zg.onPlayQualityUpdate = (streamId, streamQuality) => {
      // log('onPlayQualityUpdate',streamId,streamQuality)
      const {
        videoBitrate,
        audioBitrate,
        videoFPS,
        frameHeight,
        frameWidth,
        videoTransferFPS,
      } = streamQuality;
      log(
        'onPlayQualityUpdate',
        streamId,
        `videoBitrate:${videoBitrate | 0}`,
        `audioBitrate:${audioBitrate | 0}`,
        `videoFPS:${videoFPS | 0}`,
        `frameHeight:${frameHeight | 0}`,
        `frameWidth:${frameWidth | 0}`,
        `videoTransferFPS:${videoTransferFPS | 0}`,
      );
      this.onPlayQualityUpdate(streamId, streamQuality);
    };

    // 推流状态变更通知
    // type start:0, error:1, retry: 2
    this.zg.onPublishStateUpdate = (type, streamId, error) => {
      this.trackLog(
        'onPublishStateUpdate',
        {
          type,
          error,
        },
        {
          streamId,
          type: STATE_TYPE[type],
        },
      );

      // if (type === 0) {
      //   this.onUpdatePublishState(streamId, true)
      // } else if (type === 1) {
      //   this.onUpdatePublishState(streamId, false)
      // }
      if (type === 0) {
        this.onStartPublishingStream(true);
        this.isPublishing = true;
      } else {
        this.isPublishing = false;
      }

      this.onPublishStateUpdate(type, streamId, error.code);
    };

    this.zg.onPublishQualityUpdate = (streamId, streamQuality) => {
      // log('onPublishQualityUpdate',streamId,streamQuality)
      let { videoBitrate, audioBitrate, videoFPS, audioFPS, videoTransferFPS } =
        streamQuality;

      videoBitrate |= 0;
      audioBitrate |= 0;
      videoFPS |= 0;
      audioFPS |= 0;
      videoTransferFPS |= 0;

      log(
        'onPublishQualityUpdate',
        streamId,
        `videoBitrate:${videoBitrate}`,
        `audioBitrate:${audioBitrate}`,
        `videoFPS:${videoFPS}`,
        `videoTransferFPS:${videoTransferFPS}`,
      );

      track.send({
        event: this.trackName,
        event_type: 'onPublishQualityUpdate',
        push_anchor_id: this.anchorId,
        push_rtmp_url: this.pushRtmpUrl,
        deviceName: 'PC',
        fps: videoFPS | 0,
        kbps: videoBitrate | 0,
        afps: audioFPS | 0,
        akbps: audioBitrate | 0,
        streamType: STREAM_TYPE[this.streamType] || 0,
      });
      this.onPublishQualityUpdate(streamId, streamQuality);
    };

    this.zg.setSoundLevelDelegate(true, 200);

    this.zg.onSoundLevelUpdate = (soundLevelList) => {
      // log('onSoundLevelUpdate', soundLevelList);
      this.onSoundLevelUpdate(
        soundLevelList.filter((item) => {
          return item.streamID;
        }),
      );
    };

    this._loginZego();
  }

  _loginZego() {
    request.cryolite
      .get('api/v5/zego/auth-token', {
        id_name: this.loginUserId,
      })
      .then(async (res) => {
        const zegoToken = res.data.auth_token;
        const roomId = this.roomId;
        log('start login zego,', 'roomId:', roomId, ' token:', zegoToken);
        this.zg.login(
          roomId,
          1,
          zegoToken,
          (streamList) => {
            this.onLoginZego(true);
            this.isLoginZego = true;

            this.trackLog(
              'loginZego_success',
              { streamList },
              {
                roomId,
              },
            );
          },
          (err) => {
            this.isLoginZego = false;
            error('login zego err', err);
          },
        );
      })
      .catch((err) => {
        this.trackLog(
          'loginZego_fail',
          {
            err,
          },
          {
            roomId,
          },
        );
        UiToast.fail('获取房间推流参数异常');
      });
  }

  getDeviceList(cb) {
    this.zg.enumDevices(
      (deviceInfo) => {
        this.trackLog('getDeviceList', deviceInfo);
        cb(deviceInfo);
      },
      (err) => {
        this.trackLog('getDeviceList_err', err);
        UiModal.alert('提示', '获取媒体设备信息异常');
      },
    );
  }

  startPreview(opts) {
    const {
      video,
      hasVideo,
      videoInput,
      audioInput,
      success,
      error,
      previewConfig = {},
    } = opts;
    const config = assign(
      {
        audio: true,
        audioInput,
        video: hasVideo,
        videoInput: videoInput || null,
        horizontal: true,
        videoQuality: 4,
        width: 480,
        height: 640,
        frameRate: 15,
        // bitRate: isTopc ? 800 : 100,
        bitRate: {
          minBitRate: 400, // isTopc?800:100,
          maxBitRate: 1200, // isTopc?1200:200
        },
        audioBitRate: 48000,
        noiseSuppression: true,
        autoGainControl: true,
        echoCancellation: true,
      },
      previewConfig,
      globalPageConfig.getConfig().zgConfig || {},
    );

    log('startPreview config', config, !!video);
    this.starVideo = video;
    this.zg.startPreview(
      video,
      config,
      () => {
        this.trackLog('startPreview', config);
        this.isPreviewed = true;
        success && success();
      },
      (reason) => {
        UiToast.fail('推流预览失败，请开启摄像头、麦克风权限后重试');
        log('startPreview error');
        this.trackLog('startPreview_err', {
          config,
          reason,
        });
        this.isPreviewed = false;
        error && error();
      },
    );
  }

  stopPreview(video) {
    this.trackLog('stopPreview', null, null, video);
    this.isPreviewed = false;
    this.zg && this.zg.stopPreview(video);
  }

  enableCamera(video, enable) {
    if (!this.isPreviewed) {
      log('enableCamera not previewed');
      return;
    }
    video = video || this.starVideo;
    this.trackLog(
      'enableCamera',
      {
        enable,
        hasVideo: !!video,
      },
      null,
      video,
    );
    this.zg.enableCamera(video, enable);
  }

  enableMicrophone(video, enable) {
    if (!this.isPreviewed) {
      log('enableMicrophone not previewed');
      return;
    }
    video = video || this.starVideo;
    this.trackLog(
      'enableMicrophone',
      {
        enable,
        hasVideo: !!video,
      },
      null,
      video,
    );
    this.zg.enableMicrophone(video, enable);
  }

  startPublishingStream(video, extraInfo, cb) {
    if (this.isLoginZego) {
      this.starVideo = video || this.starVideo;
      log('startPublishingStream', this.starVideo, extraInfo);

      this.streamId = `${extraInfo?.streamId || this.streamId}`;

      request.cryolite
        .get('api/v5/zego/push-key', {
          stream_id: this.streamId,
        })
        .then(async (res) => {
          this.pushRtmpUrl = res.data.push_url;
          this.trackLog('startPublishingStream', {
            extraInfo,
            cdnUrl: res.data.push_url,
          });
          this.zg.startPublishingStream(
            this.streamId,
            this.starVideo,
            JSON.stringify(extraInfo),
            {
              cdnUrl: res.data.push_url,
            },
          );
        })
        .catch((err) => {
          UiToast.fail('获取推流key异常');
          error('get zego push key error', err);
        });
    } else {
      UiToast.fail('推流状态异常');
    }
  }

  stopPublishingStream(video) {
    video = video || this.starVideo;
    // getStore().room.updatePublishingStreamStatus(false)
    this.trackLog('stopPublishingStream', {
      streamId: this.streamId,
    });
    // 兼容网页端的开播工具
    if (!window.inPcClient) {
      this.stopPreview(video);
    }
    // if(getStore().room.isPublishingStream) {
    this.zg && this.zg.stopPublishingStream(this.streamId);
    // }

    this.isPublishing = false;

    this.onStopPublishingStream();
  }

  startPlayingStream(streamId, video, onFail) {
    const result = this.zg.startPlayingStream(streamId + '', video);
    // video.muted = false;
    if (!result) {
      onFail && onFail();
      console.error('播放失败');
    }

    this.trackLog(
      'startPlayingStream',
      {
        streamId,
        result,
      },
      null,
      video,
    );

    return () => {
      this.stopPlayingStream(streamId);
    };
  }

  mutePlayStreamAudio(streamId, mute, video) {
    this.trackLog('mutePlayStreamAudio', { streamId, mute });
    video.muted = !mute;
    // this.zg?.mutePlayStreamAudio(streamId,mute);
  }

  stopPlayingStream(streamId) {
    log('stopPlayingStream', streamId);
    this.trackLog(
      'stopPlayingStream',
      {},
      {
        streamId,
      },
    );
    this.zg.stopPlayingStream(streamId);
  }

  /**
   *
   * @param type anchorRoom | topc | sm | pk_host | pk_star
   * @param isJoinLive 主要用来控制 3A 参数
   */
  updateStream(type, isJoinLive) {
    if (!this.isPublishing) {
      this.trackLog('updateStream', 'not publishing');
      return;
    }
    this.streamType = type;

    const constraints = {
      ...(isJoinLive
        ? globalPageConfig.getConfig().joinLine3A
        : globalPageConfig.getConfig().default3A),
      ...globalPageConfig.getClientStreamConfig({
        streamType: type,
      }),
    };
    this.trackLog('updateStream', {
      type,
      isJoinLive,
      constraints,
      userId: this.userId,
    });

    // track.send({
    //   event: this.trackName,
    //   event_type: 'setPublishStreamConstraints',
    //   content: {
    //     streamType: this.streamType,
    //     constraints,
    //   },
    // });

    const getResult = () => {
      const video = this.starVideo;

      let audioTracks;
      let isSame;

      if (video) {
        audioTracks = video.srcObject.getAudioTracks()[0].getSettings();
        isSame =
          constraints.autoGainControl === audioTracks.autoGainControl &&
          constraints.echoCancellation === audioTracks.echoCancellation &&
          constraints.noiseSuppression === audioTracks.noiseSuppression;

        log('updateStream result', video.videoHeight, video.videoWidth, {
          type,
          isJoinLive,
        });

        const cb = () => {
          log(
            'updateStream second result',
            video.videoHeight,
            video.videoWidth,
          );
        };

        if (type === 'anchorRoomPortrait') {
          //! isJoinLive &&
          if (video.videoHeight < 1080) {
            setTimeout(() => {
              constraints.height = video.videoHeight;
              constraints.width = Math.floor((video.videoHeight / 16) * 9);
              this.zg &&
                this.zg.setPublishStreamConstraints(
                  this.userId,
                  constraints,
                  cb,
                );
            }, 1000);
          }
        }
      }
      return {
        isSame,
        audioTracks,
      };
    };

    this.zg &&
      this.zg.setPublishStreamConstraints(
        this.streamId,
        constraints,
        () => {
          this.trackLog('setPublishStreamConstraints_success', {
            streamType: this.streamType,
            constraints,
            ...getResult(),
          });
        },
        (error) => {
          this.trackLog('setPublishStreamConstraints_err', {
            streamType: this.streamType,
            constraints,
            ...getResult(),
            error,
          });
        },
      );
  }

  setVideoEncoderConfig(opt) {
    // 目前暂时只有多人派对厅用，默认都开启3A
    opt.noiseSuppression = true;
    opt.autoGainControl = true;
    opt.echoCancellation = true;

    if (!this.isPublishing) {
      this.trackLog('setVideoEncoderConfig', 'not publishing');
      return;
    }
    this.trackLog('setVideoEncoderConfig', opt);
    this.zg &&
      this.zg.setPublishStreamConstraints(
        this.streamId,
        opt,
        () => {
          this.trackLog('setPublishStreamConstraints_success', {
            streamType: this.streamType,
            from: 'setVideoEncoderConfig',
            opt,
          });
        },
        (error) => {
          this.trackLog('setPublishStreamConstraints_err', {
            streamType: this.streamType,
            from: 'setVideoEncoderConfig',
            opt,
            error,
          });
        },
      );
  }

  destroy() {
    this.trackLog('destroy');

    this.isLoginZego = false;
    this.zg && this.zg.release();
  }

  onDisconnect() {}

  onKickOut() {}

  onStreamUpdated(type, streamList) {}

  onPlayStateUpdate(type, streamId, error) {}

  onVideoSizeChanged(streamId, videoWidth, videoHeight) {}

  onPlayQualityUpdate(streamId, streamQuality) {}

  onPublishStateUpdate(type, streamId, error) {}

  onPublishQualityUpdate(streamId, streamQuality) {}

  onLoginZego(status) {}

  onStartPublishingStream(status) {}

  onStopPublishingStream() {}

  onSoundLevelUpdate(soundLevelList) {}

  // onUpdatePublishState(stream_id, isSuccess){}
}

export default ZegoBase;
